import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';

import api from 'api';
import Builder from 'partials/Builder';
import css from 'css';

import { redirect404, checkResourcePath, gtmPush, decodeHtml } from 'helpers';
import HeadMeta from 'partials/HeadMeta';
import Footer from 'partials/Footer';
import ErrorBoundary from 'partials/ErrorBoundary';

import { setCurrentView } from 'store';

class Page extends Component {

    constructor(props) {
        super(props)

        this.state = {
            notFound: false
        }
    }

    componentDidMount() {
        this.mounted = true;

        this._loadPageData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.location.pathname !== prevProps.location.pathname) {
            this._loadPageData();
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    _loadPageData() {
        api.getPageBySlug(this.props.match.params.slug)
            .then(resp => {
                if(resp.data[0]) {
                    const page = resp.data[0];

                    // checkResourcePath() will redirect to 404 if resource.link !== location.pathname
                    if(!checkResourcePath(page, this.props.location)) return;
                    this.props.setCurrentView(page);


                    // GTM datalayer push
                    if(window.firstLoad === false) {
                        let title = page.yoast.title;
                        if(!title && page.title && page.title.rendered) title = page.title.rendered;
                        if(!title && page.post_title) title = page.post_title;
                        if(!title && page.name) title = page.name; // for terms
                        gtmPush({
                            'event': 'pageview',
                            'page': {
                                'path': this.props.location.pathname,
                                'title': decodeHtml(title)
                            }
                        });
                    }
                    window.firstLoad = false;

                    //window.prerenderReady = true;
                    //console.log('ready', window.prerenderReady);

                } else {
                    this.setState({ notFound: true })
                }
            })
            .catch(e => console.log(e));
    }

    render() {
        const { page } = this.props;

        const pageBackground = page && page.acf && page.acf.page_background ? page.acf.page_background : 'white';

        if(this.state.notFound)  {
            redirect404();
            return null;
        }

        if(!page) return null

        return (
            <Wrapper pageBackground={pageBackground}>

                <HeadMeta page={page} />

                <ErrorBoundary for="Page builder">
                    <Builder data={(page.acf && page.acf.modules) || []} page={page}  />
                </ErrorBoundary>

                <ErrorBoundary for="Footer">
                    <Footer/>
                </ErrorBoundary>

            </Wrapper>
        );
    }
}

const mapStateToProps = (state, props) => ({
    page: state.pages[props.match.params.slug] || null
});

const actions = {
    setCurrentView,
}

export default connect(mapStateToProps, actions)(withRouter(Page));

const Wrapper = styled.div`
    display:block;
    position:relative;
    width:100%;

    background: ${props => css.colors[props.pageBackground]};
`


// WEBPACK FOOTER //
// ./src/views/Page.js